import { ClockTimestamp } from '@sqior/js/data';

export enum ORWorkflowCountdownType {
  Emergency = 'emergency',
  Transport = 'transport',
  Anesthesia = 'anesthesia',
  Surgery = 'surgery',
}

export enum ORWorkflowIndicatorState {
  TransportOrdered = 'transport-ordered',
  TransportRunning = 'transport-running',
  TransportCancelled = 'transport-cancelled',
}

/** View model describing a common indicator for OR workflows */

export type ORWorkflowIndicatorVM =
  | {
      countdownType: ORWorkflowCountdownType;
      countdown?: ClockTimestamp;
      countdownStart?: ClockTimestamp;
      countdownDuration?: ClockTimestamp;
    }
  | ORWorkflowIndicatorState;
